import { CardTypes } from 'features/payment/types';

import { ICartEntry, ISanityImage } from '@rbi-ctg/menu';
import { IRestaurant } from '@rbi-ctg/store';
import { IAppliedOffer } from 'generated/graphql-gateway';
import { IParsedLoyaltyReward } from 'state/loyalty/hooks/types';
import { IUseCartTip } from 'state/order/hooks/use-cart-tip';
import { ServiceMode } from 'state/service-mode';
import { IPlaceAddress } from 'utils/geolocation';

export type WISanityImage = { -readonly [K in keyof ISanityImage]: ISanityImage[K] | null };

export interface IUsePriceOrderParams {
  cartEntries: ICartEntry[];
  orderStatusPollInterval?: number;
  skipOrderStatusPolling?: boolean;
  updateTipAmount?: IUseCartTip['updateTipAmount'];
}

export interface IPriceOrderParams {
  appliedOffers?: IAppliedOffer[];
  rewardsApplied?: IParsedLoyaltyReward[] | null;
  cardType?: CardTypes | null;
  cartEntries: ICartEntry[];
  customerLocale?: string;
  customerName?: string | null;
  deliveryAddress?: IPlaceAddress | null;
  deliveryInstructions?: string;
  orderPhoneNumber?: string | null;
  loyaltyBarcode?: string | null;
  redeemReward?: boolean | null;
  requestedAmountCents: number;
  serviceMode: ServiceMode;
  store: IRestaurant;
  tipCents?: number;
  isStoreOpenAndAvailable?: boolean;
  vatNumber?: string;
}
